<div class="products-container">
  @if (groupedProducts?.length) {
    @for (group of groupedProducts; track trackByGroupId($index, group)) {
      <div class="group-header">
        <mat-checkbox
          class="checkbox checkbox-bg"
          [checked]="isGroupSelected(group)"
          [indeterminate]="isGroupPartiallySelected(group)"
          (change)="toggleSelectGroup($event, group)"
        >
          @if (group.name) {
            {{ group.name }}
          } @else {
            @if (group.type) {
              {{ productTypeTranslations[group.type] | transloco }}
            } @else {
              {{ 'pos_dashboard.no_group' | transloco }}
            }
          }
        </mat-checkbox>
      </div>
      <div class="group-products-container">
        @for (product of group.products; track trackByProductId($index, product)) {
          <div class="product-tab">
            @if (product?.media) {
              <img class="product-img" [lazyLoad]="getThumbnailUrl(product?.media[0]?.url1x)" />
            }
            @if (!product?.media) {
              <div class="product-img placeholder-img"></div>
            }
            <mat-checkbox
              class="checkbox"
              [checked]="product?.isSelected"
              (change)="toggleSelectProduct($event, product)"
            ></mat-checkbox>
            <p class="mr-3">{{ product.public_name }}</p>
            @if (product.private_name && product.private_name !== product.public_name) {
              <p class="product-private-name mr-3">
                {{ product.private_name }}
              </p>
            }
          </div>
        }
      </div>
    }
  }
</div>
